import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
    infor:{}
  },
  mutations: {
    setInfor(state,obj){
      state.infor = obj
    }
  },
  actions: {
    getwzxx(context,infor){
      context.commit('setInfor',infor)
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
